import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import { openModal } from '../store/altenateArt'
import styles from '../styles/Card.module.scss'
import { useDispatch } from 'react-redux'

const AlternateArtButton = ({ cardProps }) => {
  const dispatch = useDispatch()
  return (
    <div
      className={classNames(
        styles.clipboardButtonOuter,
        styles.alternateArtButtonOuter
      )}
      onClick={() => dispatch(openModal(cardProps))}
    >
      <div className={styles.clipboardButton}>
        <FontAwesomeIcon className={styles.clipboardButtonIcon} icon='eye' />
      </div>
    </div>
  )
}

export default AlternateArtButton
